if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        // Skip the scroll-linked observer inside the Theme Editor: sections
        // there re-render on every settings change, and there's no value in
        // running scroll-tracking JS against a preview iframe.
        if (window.Shopify && window.Shopify.designMode) return;

        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('[data-sticky-atc-button]');
        if (!this.mainButton || !this.button) return;

        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);

        // Dawn replaces the whole <product-info> subtree (including this
        // element) on every variant change, which destroys and recreates
        // this custom element — connectedCallback re-runs automatically and
        // re-observes the new submit button, so the bar always tracks the
        // current variant without any extra sync logic.
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', scrolledPast);
            });
          });
          this.observer.observe(this.mainButton);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      onClick() {
        if (this.dataset.hasVariant !== 'true') {
          const productInfo = this.closest('product-info') || document.getElementById(`MainProduct-${this.sectionId}`);
          const variantPicker = productInfo?.querySelector('.product-form__input');
          (variantPicker || this.mainButton).scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        this.mainButton.click();
      }
    }
  );
}
